var SECONDARY_MEDIA_TRIGGER = {
    OFF: 'OFF',
    HOVER: 'HOVER',
};
export default SECONDARY_MEDIA_TRIGGER;
//# sourceMappingURL=secondaryMediaTrigger.js.map